<template>
  <section class="w-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    >
    </TopAppBar>
    <div class="pda-default">
      <form @submit.prevent="next()" novalidate>
        <div class="t-headline5">
          {{ $t("794") }}
          <!-- 코드 인증 -->
        </div>
        <!-- v-html="$t('762', {str1: `<strong>${join.dutyName}</strong>`, str2: `<strong>${join.responsibilityName}</strong>`})" -->
        <div
          class="t-body3 mgt-6 t-color-content1"
          v-html="
            $t('795', {
              str1: `<strong>${memberDutyName}</strong>`,
              str2: `<strong>${memberResponsibilityName}</strong>`,
            })
          "
        >
          <!-- 직무 A 직책 B 에 해당하는 인증코드를 입력하세요. -->
        </div>
        <!-- <div class="t-body3 mgt-6 t-color-content1" v-html="$t('795', {str1: `<strong>${join.dutyName}</strong>`, str2: `<strong>${join.responsibilityName}</strong>`})">
            </div> -->
        <div class="mgt-35">
          <div
            class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
            :class="
              submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''
            "
            id="codeEl"
          >
            <i class="material-icons mdc-text-field__icon">
              {{ validIcon }}
            </i>
            <input
              type="text"
              class="mdc-text-field__input"
              v-model="code"
              v-validate="'required|alpha_num'"
              ref="code"
              id="code"
              name="code"
              maxlength="50"
            />
            <div class="mdc-notched-outline">
              <div class="mdc-notched-outline__leading"></div>
              <div class="mdc-notched-outline__notch">
                <label for="tf-outlined" class="mdc-floating-label">
                  {{ $t("796") }}
                  <!-- 코드입력 -->
                </label>
              </div>
              <div class="mdc-notched-outline__trailing"></div>
            </div>
          </div>
          <div
            class="t-helper mgl-7 mgr-7 pdt-2 min-h-23"
            :class="submitState && codeInvalidCheck ? 't-color-red1' : ''"
          >
            <span v-if="submitState && codeInvalidCheck">
              {{ $t("797") }}
              <!-- * 공백이 없는 인증코드를 입력하세요. -->
            </span>
            <span v-else>
              {{ $t("797") }}
              <!-- * 본인 및 소속을 확인하기 위한 코드 인증입니다. -->
            </span>
          </div>
        </div>

        <div class="mgt-50">
          <button class="mdc-button mdc-button--raised btn-red" @click="next()">
            {{ $t("798") }}
            <!-- 다음 -->
          </button>
          <button
            class="mdc-button btn-white mgr-8 mgl-8"
            @click="cancelJoin_local()"
            type="button"
          >
            {{ $t("1554") }}
            <!-- 취소 -->
          </button>
        </div>
      </form>

      <div class="mgt-30 t-body4 t-color-gray1">
        <a @click="showMessage(1)">
          {{ $t("799") }}
          <!-- 인증코드를 잊음 -->
        </a>
        {{ $t("800") }}
        <!-- 혹은 -->
        <a @click="showMessage(2)">
          {{ $t("801") }}
          <!-- 인증코드가 없음 -->
        </a>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 회원가입 - 코드인증 컴포넌트(sign up - auth code component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi.js";
import { mapState, mapMutations } from "vuex";
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import { joinMixin } from "@/mixins/join.js";
import { commonMixin } from "@/mixins/common.js";
import popupApi from "@/api/popupApi.js";
import loginApi from "@/api/loginApi.js";
import brandApi from "@/api/brandApi.js";

export default {
  data() {
    return {
      code: "",
      codeTextField: null,
      submitState: false,
      validIcon: "",
      popupData: null,
      redirectPath: "",
      memberDutyName: "",
      memberResponsibilityName: "",
      params: "",
      redirectPath: "",
      popupData: null,
      popupImage: null,
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      socialAuth: false,
      isDrawerOpen: false,
      staticMode: "",
    };
  },

  components: {
    TopAppBar,
  },

  watch: {
    $route(to, from) {
      this.setTopAppBarCloseOnly("");
    },
  },

  mixins: [topAppBarMixin, joinMixin, commonMixin],

  computed: {
    // code 유효성 Check 및 아이콘(validation code & set icon)
    codeInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("code")) {
          returnValue = true;
          this.validIcon = "warning";
        } else {
          returnValue = false;
          this.validIcon = "";
        }
      }
      this.codeTextField.valid === !returnValue
        ? ""
        : (this.codeTextField.valid = !returnValue);
      return returnValue;
    },
  },
  created() {
    // if (!this.join.responsibility) {
    //     this.moveJoin2Intro()
    // }
  },
  mounted() {
    this.setMaterialUi();
    this.$refs.code.focus();
    this.setTopAppBarCloseOnly("");
    this.paramsss = JSON.parse(localStorage.getItem("userParams"));
    memberApi.getMemberInfo().then((response) => {
      console.log("getMemberInfo", response.data.data);
      let responseData = response.data.data;
      this.memberDutyName = responseData.dutyName;
      this.memberResponsibilityName = responseData.responsibilityName;
    });
  },

  methods: {
    // Store 변이 정의(define store mutation)
    //...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_CODE']),

    ...mapMutations("join", [
      "SET_JOINSTART",
      "SET_SOCIAL_LINK",
      "SET_NAME_FIRST",
      "SET_NAME_LAST",
      "SET_NAME_FULL",
      "SET_LOGINID",
      "SET_SOCIAL_ID",
      "INIT_JOIN_STORE",
    ]),

    setMaterialUi() {
      this.codeTextField = new MDCTextField(document.querySelector("#codeEl"));
      this.codeTextField.useNativeValidation = false;
      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },

    next() {
      this.$validator.validateAll().then((resultValid) => {
        this.submitState = true;

        if (resultValid) {
          let params = {
            code: this.code,
          };

          // code auth
          memberApi
            .authResponsibility(params)
            .then((response) => {
              console.log("responseCode=>", response.data);
              //this.SET_CODE(this.code)
              if (response.data.data === true) {
                this.checkSignInStatus();
              }
            })
            .catch((err) => {
              // this.$snackOpen({contents:'인증에 실패했습니다. 코드를 확인해주세요.', btnDisplayYN: false}).then(() => {})
              this.$snackOpen({
                contents: this.$t("1558") + " " + this.$t("1559"),
                btnDisplay: "",
              }).then(() => {});
            });
        }
      });
    },
    checkSignInStatus() {
      let paramss = this.paramsss;
      loginApi
        .login(paramss)
        .then((response) => {
          let responseData = response.data.data;
          let changePasswordRequest = responseData.changePasswordRequest;
          let reIssueChangePassword = responseData.reIssueChangePassword;
          let emailAuth = responseData.emailAuth;
          let dormancy = responseData.dormancy;
          let responsibilityAuth = responseData.responsibilityAuth;
          let termsAgree = responseData.termsAgree;
          loginApi.setAuthInHeader(responseData.token);

          if (dormancy === true) {
            this.$alert({
              title: this.$t("824"),
              content:
                this.$t("825") +
                " " +
                this.$t("826") +
                "<br>" +
                this.$t("827", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("828", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("829"),
            })
              .then(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              })
              .catch(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              });
          } else if (termsAgree === false) {
            this.$router.push("/termsagree");
          } else if (emailAuth === false) {
            this.$confirm({
              title: this.$t("804"),
              content: this.$t("805") + " " + this.$t("806"),
              accept: this.$t("835"),
              cancel: this.$t("834"),
            })
              .then(() => {
                this.$router.push("/emailvarification");
              })
              .catch(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              });
          } else if (changePasswordRequest === true) {
            this.$router.push({ name: "MemberChangePassword" });
          } else if (reIssueChangePassword === true) {
            this.$router.push({ name: "MemberReIssueChangePassword" });
          } else {
            loginApi.setAuthInHeader(responseData.token);
            this.redirectPath = this.$route.query.redirectPath || "/home";
            this.title = localStorage.getItem("brandName") || this.$t("286");
            this.callPushNotification();
            this.$router.push(this.redirectPath);
          }
        })
        .catch((err) => {
          console.log("LOGIN FLOW ERROR : ", err);
          const responseData = err.response.data.meta;

          console.log("responseData", responseData);

          if (responseData.errCode === 1201) {
            //관리자 승인 대기중(Waiting for administrator approval)
            // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
            //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1202) {
            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1204) {
            this.$alert({
              title: this.$t("1482"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1483") +
                "<br>" +
                this.$t("1484") +
                ": " +
                '<a href="mailto:' +
                BRAND_MANAGER_EMAIL +
                '">' +
                BRAND_MANAGER_EMAIL +
                "</a>" +
                "<br>" +
                this.$t("1485") +
                ": " +
                '<a href="tel:' +
                BRAND_MANAGER_PHONE +
                '">' +
                BRAND_MANAGER_PHONE +
                "</a>",
              accept: this.$t("1486"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1205) {
            this.$alert({
              title: this.$t("1914"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1915") +
                " " +
                this.$t("1916") +
                "<br>" +
                this.$t("1917", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("1918", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("1919"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1105) {
            this.$alert({
              content: this.$t("1875"),
              accept: this.$t("1876"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1335) {
            //아이디 계정 일시 정지(Suspend Account)
            // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
            this.$snackOpen({
              contents: this.$t("323"),
              btnDisplayYN: false,
            }).then(() => {});
          } else {
          }
        });
    },
    signOutFirebase() {
      firebase.auth().signOut();
    },
    setTopAppBarCloseOnly(title) {
      this.leftBtnMode = "close";
      this.rightBtnMode = "";
      this.title = title || this.title;
      this.leftBtnMethod = () => {
        this.$router.go(-1);
      };
      this.rightBtnMethod = "";
    },
    cancelJoin_local() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
  },
};
</script>